export default __webpack_public_path__ + "static/esgReport2020-82775e1159132a4bb15e4e36fde50498.pdf";